import React from 'react';
import { useStyles } from '@webapps/styles';
import { ShareOutlined } from '@material-ui/icons';
import { Button } from '@material-ui/core';

export default function CalendarInSchedule() {
  const { classes } = useStyles(styles);

  return (
    <div className={classes["framerDiv"]}>
      <div className={classes["framerDiv2"]}>
        <div className={classes["framerDiv3"]}>
          <div className={classes["framerP"]}>Mai 2025</div>
          <Button className={classes["framerButton"]}>
            <ShareOutlined className={classes["framerIcon1"]} />
          </Button>
          <Button className={classes["framerButton"]}>
            <ShareOutlined className={classes["framerIcon1"]} />
          </Button>
        </div>
        <div className={classes["framerDiv4"]}>
          <div className={classes["framerDiv5"]}>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Lun</div>
            </div>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Mar</div>
            </div>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Mer</div>
            </div>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Jeu</div>
            </div>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Ven</div>
            </div>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Sam</div>
            </div>
            <div className={classes["framerDiv6"]}>
              <div className={classes["framerP2"]}>Dim</div>
            </div>
          </div>
          <div className={classes["framerDiv7"]}>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
          </div>
          <div className={classes["framerDiv8"]}>
            <div className={classes["framerDiv9"]}>
              <div className={classes["framerDiv10"]} />
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
              </Button>
              <Button className={classes["framerButton2"]}>
                <div className={classes["framerP2"]}>0</div>
              </Button>
              <Button className={classes["framerButton2"]}>
                <div className={classes["framerP2"]}>0</div>
              </Button>
            </div>
          </div>
          <div className={classes["framerDiv11"]}>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
          </div>
          <div className={classes["framerDiv12"]}>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
          </div>
          <div className={classes["framerDiv13"]}>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
            <Button className={classes["framerButton2"]}>
              <div className={classes["framerP2"]}>0</div>
            </Button>
          </div>
          <div className={classes["framerDiv14"]}>
            <div className={classes["framerDiv9"]}>
              <div className={classes["framerDiv10"]} />
              <Button className={classes["framerButton4"]}>
                <div className={classes["framerP4"]}>0</div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
                <div className={classes["framerDiv15"]}>
                  <ShareOutlined className={classes["framerIcon2"]} />
                </div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
                <div className={classes["framerDiv15"]}>
                  <ShareOutlined className={classes["framerIcon2"]} />
                </div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
                <div className={classes["framerDiv15"]}>
                  <ShareOutlined className={classes["framerIcon2"]} />
                </div>
              </Button>
              <Button className={classes["framerButton3"]}>
                <div className={classes["framerP3"]}>0</div>
                <div className={classes["framerDiv15"]}>
                  <ShareOutlined className={classes["framerIcon2"]} />
                </div>
              </Button>
              <Button className={classes["framerButton2"]}>
                <div className={classes["framerP2"]}>0</div>
              </Button>
              <Button className={classes["framerButton2"]}>
                <div className={classes["framerP2"]}>0</div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = ({ spacing }) => ({
  "framerDiv": {
    position: "relative",
  },
  "framerDiv2": {
    alignItems: "flex-start",
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    justifyContent: "flex-start",
    paddingBottom: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "20px",
    position: "relative",
    width: "403px",
    gap: "16px",
    overflow: "visible",
  },
  "framerDiv3": {
    alignContent: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    position: "relative",
    width: "100%",
    gap: "10px",
    overflow: "visible",
    placeItems: "center",
  },
  "framerP": {
    fontFamily: "\"Montserrat\", sans-serif",
    fontSize: "15px",
    fontWeight: "600",
    color: "#152652",
  },
  "framerButton": {
    borderBottomWidth: "1px",
    borderColor: "#c0d9ff",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderTopWidth: "1px",
    alignContent: "center",
    backgroundColor: "#f3f7ff",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    display: "flex",
    flexDirection: "row",
    height: "26px",
    position: "relative",
    width: "26px",
    overflow: "visible",
    placeItems: "center",
    "&:hover": {
      "& $framerButton": {
        borderColor: "#0060f9",
        height: "100%",
        width: "100%",
      },
      "& $framerIcon1": {
        fill: "#0060f9",
      },
      borderColor: "#0060f9",
    },
  },
  "framerIcon1": {
    height: "16px",
    position: "relative",
    width: "16px",
    fill: "#5d75a8",
  },
  "framerDiv4": {
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    position: "relative",
    width: "100%",
    gap: "10px",
    overflow: "hidden",
    placeItems: "center",
  },
  "framerDiv5": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    overflow: "visible",
  },
  "framerDiv6": {
    borderBottomLeftRadius: "40px",
    borderBottomRightRadius: "40px",
    borderTopLeftRadius: "40px",
    borderTopRightRadius: "40px",
    height: "32px",
    position: "relative",
    width: "32px",
    overflow: "hidden",
  },
  "framerP2": {
    fontFamily: "\"Poppins\", sans-serif",
    fontSize: "12px",
    color: "#5d75a8",
  },
  "framerDiv7": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    order: "1",
    position: "relative",
    width: "100%",
    overflow: "visible",
  },
  "framerButton2": {
    borderColor: "rgba(0, 0, 0, 0)",
    borderStyle: "solid",
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderBottomLeftRadius: "40px",
    borderBottomRightRadius: "40px",
    borderTopLeftRadius: "40px",
    borderTopRightRadius: "40px",
    height: "32px",
    position: "relative",
    width: "32px",
    overflow: "visible",
    "&:hover": {
      "& $framerButton2": {
        backgroundColor: "#f3f7ff",
        height: "100%",
        width: "100%",
        borderBottomWidth: "1px",
        borderColor: "#c0d9ff",
        borderLeftWidth: "1px",
        borderRightWidth: "1px",
        borderTopWidth: "1px",
      },
      "& $framerP2": {
        color: "#ffffff",
      },
    },
  },
  "framerDiv8": {
    order: "4",
    position: "relative",
    width: "100%",
  },
  "framerDiv9": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    overflow: "visible",
  },
  "framerDiv10": {
    backgroundColor: "#c0d9ff",
    borderBottomLeftRadius: "30px",
    borderBottomRightRadius: "30px",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    position: "absolute",
    width: "70%",
    overflow: "visible",
  },
  "framerButton3": {
    borderColor: "rgba(0, 0, 0, 0)",
    borderStyle: "solid",
    backgroundColor: "#c0d9ff",
    borderBottomLeftRadius: "40px",
    borderBottomRightRadius: "40px",
    borderTopLeftRadius: "40px",
    borderTopRightRadius: "40px",
    height: "32px",
    position: "relative",
    width: "32px",
    overflow: "visible",
    "&:hover": {
      "& $framerButton3": {
        backgroundColor: "#0060f9",
        height: "100%",
        width: "100%",
      },
      "& $framerP3": {
        color: "#ffffff",
      },
    },
  },
  "framerP3": {
    fontFamily: "\"Poppins\", sans-serif",
    fontSize: "12px",
    color: "#0060f9",
  },
  "framerDiv11": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    order: "6",
    position: "relative",
    width: "100%",
    overflow: "visible",
  },
  "framerDiv12": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    order: "7",
    position: "relative",
    width: "100%",
    overflow: "visible",
  },
  "framerDiv13": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    order: "8",
    position: "relative",
    width: "100%",
    overflow: "visible",
  },
  "framerDiv14": {
    order: "3",
    position: "relative",
    width: "100%",
  },
  "framerButton4": {
    borderColor: "rgba(0, 0, 0, 0)",
    borderStyle: "solid",
    backgroundColor: "#0060f9",
    borderBottomLeftRadius: "40px",
    borderBottomRightRadius: "40px",
    borderTopLeftRadius: "40px",
    borderTopRightRadius: "40px",
    height: "32px",
    position: "relative",
    width: "32px",
    overflow: "visible",
    "&:hover": {
      "& $framerButton4": {
        height: "100%",
        width: "100%",
      },
    },
  },
  "framerP4": {
    fontFamily: "\"Poppins\", sans-serif",
    fontSize: "12px",
    color: "#ffffff",
  },
  "framerDiv15": {
    borderBottomWidth: "1px",
    borderColor: "#008000",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderStyle: "dashed",
    borderTopWidth: "1px",
    alignContent: "center",
    backgroundColor: "#dbfad8",
    borderBottomLeftRadius: "9px",
    borderBottomRightRadius: "9px",
    borderTopLeftRadius: "9px",
    borderTopRightRadius: "9px",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    paddingBottom: "1px",
    paddingLeft: "1px",
    paddingRight: "1px",
    paddingTop: "1px",
    position: "absolute",
    right: "-15px",
    top: "47%",
    transform: "translateY(-50%)",
    width: "min-content",
    zIndex: "8",
    gap: "30px",
    overflow: "hidden",
    placeItems: "center",
  },
  "framerIcon2": {
    height: "14px",
    position: "relative",
    width: "14px",
    fill: "#008000",
  },
});